import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: inherit;\n\n  :hover {\n    color: inherit;\n  }\n\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import NextLink from "next/link";
import Router from "next/router";
import React from "react";
import styled from "styled-components";
export var Link = styled(function(_param) {
    var href = _param.href, path = _param.path, children = _param.children, props = _object_without_properties(_param, [
        "href",
        "path",
        "children"
    ]);
    if (typeof href === "string" && !href.startsWith("/")) {
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
            href: href
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ _jsx(NextLink, {
        href: href,
        as: path,
        children: /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({}, props), {
            children: children
        }))
    });
})(_templateObject(), function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});
export function routeTo(href, path) {
    return _routeTo.apply(this, arguments);
}
function _routeTo() {
    _routeTo = _async_to_generator(function(href, path) {
        var scroll;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    scroll = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    return [
                        4,
                        Router.push(href, path)
                    ];
                case 1:
                    _state.sent();
                    if (scroll) {
                        scrollToTop();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _routeTo.apply(this, arguments);
}
function scrollToTop() {
    if (global.window) {
        global.window.scrollTo(0, 0);
    }
}
